import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-recording"
}
const _hoisted_2 = {
  key: 1,
  class: "container-recording"
}
const _hoisted_3 = { class: "processing-container" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "processing-content" }

import { ref } from "vue";
import { UserTracking } from "@/utils/UserTracking";


export default /*@__PURE__*/_defineComponent({
  __name: 'AIAssistantStartTranscription',
  props: {
  initialContext: Object,
  actionState: String,
  summaryStatus: String,
  generatingTranscription: Boolean,
},
  emits: ["update-appointment", "close"],
  setup(__props, { emit: __emit }) {

/**
 * AIAssistantStartTranscription.vue - Recording/Processing Status Display
 *
 * This component now only displays:
 * - "Recording in progress" message when summaryStatus === 'recording'
 * - "Processing" message when summaryStatus === 'processing' and generating
 *
 * Device selection has been moved to AIAssistantDeviceSelectionModal.vue
 */
const toasts = ref<any[]>([]);

const onToastDismiss = () => {
  toasts.value = [];
};

const props = __props;

const emit = __emit;

// Listen for messages from iframe (microphone permission, etc.)
if (typeof window !== "undefined") {
  window.addEventListener("message", (event) => {
    const sessionId =
      (props.initialContext as { recorderSessionId?: string } | undefined)?.recorderSessionId ?? "unknown";

    if (event.data && event.data.type === "MICROPHONE_PERMISSION_DENIED") {
      UserTracking.trackEvent("noa_recorder_mic_permission_denied", {
        session_id: sessionId,
        reason: event.data.reason ?? "unknown",
        source: "start_transcription",
        page_url: window.location.href,
      });
      toasts.value.push({
        leadingIcon: "warning",
        content: "Permissão do microfone negada. A transcrição não funcionará.",
        variant: "error",
        timeOut: 5000,
      });
    } else if (event.data && event.data.type === "IFRAME_LOADED") {
      UserTracking.trackEvent("noa_recorder_iframe_loaded", {
        session_id: sessionId,
        source: "start_transcription",
        page_url: window.location.href,
      });
      console.log("Noa recorder iframe loaded successfully");
    } else if (event.data && event.data.type === "PERMISSION_ERROR") {
      console.error("Permission error from iframe:", event.data.error);
      UserTracking.trackEvent("noa_recorder_permission_error", {
        session_id: sessionId,
        error_message: String(event.data.error ?? "unknown"),
        page_url: window.location.href,
      });
      toasts.value.push({
        leadingIcon: "warning",
        content: `Erro de permissão: ${event.data.error}`,
        variant: "error",
        timeOut: 5000,
      });
    }
  });
}

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_w_spinner = _resolveComponent("w-spinner")!
  const _component_w_toast = _resolveComponent("w-toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.summaryStatus === 'recording' && !__props.generatingTranscription)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "recording-message" }, [
            _createElementVNode("h3", null, "Gravação em andamento."),
            _createElementVNode("span", { class: "subtitle" }, "Finalize a gravação para ter acesso à transcrição.")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (__props.summaryStatus === 'processing' && __props.generatingTranscription)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            false
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_svg_icon, {
                    "_ngcontent-ng-c3496710171": "",
                    name: "end",
                    class: "ng-star-inserted"
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_w_spinner, { size: "large" }),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "recording-message" }, [
                _createElementVNode("h3", null, "Gravação Finalizada."),
                _createElementVNode("span", { class: "subtitle" }, "Gerando notas com base na transcrição.")
              ], -1))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_w_toast, {
      toasts: toasts.value,
      onDismiss: onToastDismiss
    }, null, 8, ["toasts"])
  ], 64))
}
}

})